// extracted by mini-css-extract-plugin
export default {"button":"Button_button__ufG7+","icon-box":"Button_icon-box__jSGIB","icon":"Button_icon__0ra+h"};